import { LanguageProvider, SiteFooter, SiteHeader, useLanguageValue } from "@vcn/ui";
import { Hero, Intro } from './sections/Hero'
import { Roles } from './sections/Roles'
import { Audiences } from './sections/Audiences'
import { Trust } from './sections/Trust'
import { Process } from './sections/Process'
import { Together } from './sections/Together'
import { Faq } from './sections/Faq'
import { FinalCta } from './sections/FinalCta'
import { useContent } from "./content";

function Page() {
  const { language, setLanguage } = useLanguageValue();
  const { footerLinks, ui } = useContent();

  return (
    <div className="vcn-page min-h-svh">
      <a
        href="#inhalt"
        className="sr-only rounded-full bg-white px-4 py-2 text-sm font-bold text-hub-900 focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[60]"
      >
        {ui.skipToContent}
      </a>

      <SiteHeader language={language} onLanguageChange={setLanguage} />

      <main id="inhalt">
        <Hero />
        <Intro />
        <Roles />
        <Audiences />
        <Trust />
        <Process />
        <Together />
        <Faq />
        <FinalCta />
      </main>

      <SiteFooter links={footerLinks} />
    </div>
  )
}

export function App() {
  return (
    <LanguageProvider>
      <Page />
    </LanguageProvider>
  );
}
